<template>
  <div class="hello">
    <div class="search" :style="{background:'url('+ images +')',backgroundSize:'cover'}">
      <div class="searchI">
        <img src="../assets/image/pip.png" alt="">
      </div>
      <div class="SEARCH_INPUT">
        <input type="text" class="MYINPUT" v-model="values" @keyup.13="searchEvent">
        <div class="SEARCH_ICON" @click="searchEvent">
          <img src="../assets/image/search.png" alt="">
        </div>
      </div>

    </div>

    <div class="footer">
      <div class="tabList">
        <div class="tabLis" :class="{active:item.isActive}" v-for="(item,index) in tabLis" :key="index" @click="tabEvent(index,item.id)">
          <span>{{item.name}}</span>
        </div>
      </div>
      <div class="search_content">
        <div class="undefined" v-if="searchList.length == 0">
          <img v-if="lang == 'cn'" src="../assets/image/undefined.png" alt="">
          <img v-else src="../assets/image/undefinedE.png" alt="">
        </div>
        <div class="search_div" v-else v-for="(item,index) in searchList" :key="index" @click="details(item)">
          <span>{{item.title}} <span style="color: #af011a;margin-left: 20px;">{{item.organization_name == '' ? item.name : item.organization_name}}</span>
          </span>
          <div class="search_img">
            <img v-if="types == 2 | types == 3" :src="types == 2 ? item.cover_pic.display_path :item.image.file_path"
              alt="">
            <img v-else :src="item.cover_img_src" alt="">

          </div>
        </div>
        <div style="height: 200px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
  var loading;
  export default {
    data() {
      return {
        images: require('../assets/image/bann.png'),
        values: '',
        searchList: [],
        types: 3,
        lang: 'cn'
      }
    },
    computed: {
      tabLis() {
        var arr = [
          {
            name: this.$t('language.Journalism'),
            isActive: false,
            id: 3
          }

        ];
        return arr;
      }
    },
    created() {
      if (localStorage.getItem('languageSet') == 'en') {
        this.lang = 'cn'
      } else {
        this.lang = 'en'
      }
      this.values = this.$route.query.msg;
      var index = 0;
     
     
      this.tabEvent(index, this.types);
    },

    mounted() {},
    methods: {
      ajaxFun(id) {
        if (id == undefined || id == 'undefined') {
          id = 1;
        }
        var data = {
          types: id,
          search: this.values
        }
        this.$fetch('/search/list', data).then(res => {
          this.searchList = res.data.data;
        })
      },
      tabEvent(index, id) {
        for (var i = 0; i < this.tabLis.length; i++) {
          this.tabLis[i].isActive = false;
        }
        this.tabLis[index].isActive = true;
         this.ajaxFun(id)
      },
      searchEvent() {
        if (this.values == '') {
          return
        }
        var data = {
          types: this.types,
          search: this.values
        }
        this.$fetch('/search/list', data).then(res => {
          this.searchList = res.data.data;
        })
      },
      details(item) {
        //点击跳转对应的详情
        if (this.types == 2) {

          this.$router.push({
            path: '/soliciting',
            query: {
              id: item.id
            }
          })
        } else if (this.types == 3) {

          this.$router.push({
            path: '/newsDetails',
            query: {
              id: item.news_id
            }
          })
        } else if (this.types == 1) {
          this.$fetch('/Hall/displayCategoryList').then(res => {
            if (res.code == 201) {
              this.$router.push({
                path: '/exhibition'
              })
            } else {
              if (item.photographer_type == 'multiple') {
                this.$router.push({
                  path: '/halldetail',
                  query: {
                    display_category_id: item.display_category_id,
                    exhibition_category_id: item.exhibition_category_id,
                    exhibition_apply_id: item.id,
                    userId: item.id,
                  }
                })
                return
              }
              this.$router.push({
                path: '/halldetail',
                query: {
                  display_category_id: item.display_category_id,
                  exhibition_category_id: item.exhibition_category_id,

                  userId: item.id,
                  photographer_id: item.photographer_id,
                  file_type: item.file_type
                }
              })
            }
          })


        }
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/search.css");
</style>



// WEBPACK FOOTER //
// src/pages/search.vue